import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import { ReportService } from '../../_service/report.service';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  selector: 'app-ipd-transaction-report',
  templateUrl: './ipd-transaction-report.component.html',
  styleUrls: ['./ipd-transaction-report.component.css']
})
export class IpdTransactionReportComponent implements OnInit {
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild('dischargedateRangeStart', {static: false}) dischargedateRangeStart: ElementRef;
    @ViewChild('dischargedateRangeEnd', {static: false}) dischargedateRangeEnd: ElementRef;
    @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    IpdData:any=[];private hotRegisterer = new HotTableRegisterer();alltreatments=[];treatments=[];leadStatus=[];circles=[];columnDrp:number[]=[];
    id = 'hotInstance'; settings = {colHeaders: true };bds=[];paymentOpt=[];leadallStatus=[];allbds=[];treatment='';ActionOpt=[];hideColumn:any;
    perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;roleStatus=false;circle='';sheetCircle=[];reportShow:boolean=true;
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;myrole:string;submitted = false;adminRole:boolean=true;consumablesChk='';adminInsuranceRole:boolean=true;
    search:string;lead_source:string;lead_status:string;bd:string;start_date:string='';end_date:string='';bds_copy=[];doctors_copy=[];hospitals_copy=[];treatments_copy=[];doctors=[];hospitals=[];doctor:string;hospital:string;payment_mode='';status='';dischargestart_date:string='';dischargeend_date:string='';ipdHistoryDetail = [];IpdID:any='';billedloading:boolean=true;billedloaded:boolean=false;lead_sources=[];

    constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,private reportapi:ReportService)
    {
        this.paymentOpt = ['Cash','Cashless','Reimbursement','EMI'];
        this.ActionOpt = ['Select','Upload Insurance Card','Post OPD','Post IPD'];
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        if(this.myrole=='1' || this.myrole=='9')
        {
            this.adminRole = false;
        }
        if(this.myrole=='1' || this.myrole=='5')
        {
            this.adminInsuranceRole = false;
        }
    }

    ngOnInit(): void {
        this.getbds();this.getcircle();
        this.getTreatment();
        this.getDoctor();this.getHospital();
        this.getLeadSources();
    }
    ngAfterViewInit() {
        this.loadData(0,25);
    }

    async getLeadSources()
    {
        this.leadapi.getLeadSources().subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getbds()
    {
        this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getDoctor()
    {
        this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getHospital()
    {
        this.leadapi.gethospitals().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }


    async loadData(pageIndex,perpage)
    {
        this.IpdData = [];
        this.paginator.pageIndex = pageIndex;
        this.paginatorBottom.pageIndex = pageIndex;
        this.pageIndex = pageIndex;
        let qString = 'search='+this.search+'&bd='+this.bd+'&circle='+this.circle+'&hospital='+this.hospital+'&doctor='+this.doctor+'&treatment='+this.treatment+'&payment_mode='+this.payment_mode+'&date_range='+this.start_date+'-'+this.end_date+'&discharge_date_range='+this.dischargestart_date+'-'+this.dischargeend_date+'&status='+this.status+'&lead_source='+this.lead_source;
        this.loading = true;this.loaded = false;
        this.reportapi.getIpdTransReport(pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            console.log(data.data);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                
                this.IpdData = data.data;

            }else{
                this.IpdData = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    setSearchValue(type){
      if(type=='lead_owner'){
          $("#ownerSearch").val('');
          $("#ownerSearch").focus();
          this.bds= this.bds_copy;
      }else if(type=='doctor'){
          $("#doctorSearch").val('');
          $("#doctorSearch").focus();
          this.doctors= this.doctors_copy;
      }else if(type=='hospital'){
          $("#hospitalSearch").val('');
          $("#hospitalSearch").focus();
          this.hospitals= this.hospitals_copy;
      }else if(type=='treatment'){
          $("#treatmentSearch").val('');
          $("#treatmentSearch").focus();
          this.treatments= this.treatments_copy;
      }
  }

    searchOnSelect(searchtText: string, type)
    {
        if(type == 'lead_owner'){
            this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'doctor'){
            this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
        }else if(type == 'hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }



    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadData(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadData(event.pageIndex,event.pageSize);
    }
    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            this.loadData(0,this.perpage);
        }
    }

    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        this.loadData(0,this.perpage);
    }

    dischargedateRangeChange(dischargedate1,dischargedate2)
    {
        if(dischargedate2.value)
        {
            this.dischargestart_date = dischargedate1.value;
            this.dischargeend_date = dischargedate2.value;
            this.loadData(0,this.perpage);
        }
    }

    dischargeclearDate()
    {
        this.dischargedateRangeStart.nativeElement.value = "";
        this.dischargedateRangeEnd.nativeElement.value = "";
        this.dischargestart_date = '';
        this.dischargeend_date = '';
        this.loadData(0,this.perpage);
    }

    exportTransactionList()
    {
        if(this.IpdData.length>0 && this.myrole=='1' || this.myrole=='8' || this.myrole=='9' || this.myrole=='14')
        {
            let data = [];
            let titles = ['Appointment Id','Glamyo Appointment Id','Patient Name','Patient Mobile','Status','Circle','City Name','Lead Owner','Source Name','Refferal Type','Refferal Person Name','Refferal Person Number','Treatment','Treatment Catergory','Doctor','Hospital','Payment Mode','Lead Created Date','Surgery Date','Discharge Date','Consumables','Lapset Vendors','Anaesthetist'];

            if(this.myrole=='1' || this.myrole=='8' || this.myrole=='9' || this.myrole=='14'){
                titles.push('Billed Amount');
                titles.push('MOU Discount');
                titles.push('Copay');
                titles.push('Non Consumable');
                titles.push('Prop Deduction');
                titles.push('Insurance Paid');
                titles.push('Patient Paid');
                titles.push('Settlement Amount');
                titles.push('Doctor Amount');
                titles.push('Hospital Share');
                titles.push('Lab Charges');
                titles.push('Medicine Charges');
                titles.push('OT Charges');
                titles.push('Other Charges');
                titles.push('Glamyo Share');
            }
            data.push(titles);
            for(let key in this.IpdData)
            {
                let exdata = [this.IpdData[key].patient_id,this.IpdData[key].glamyoAppointmentId,this.IpdData[key].patient,this.IpdData[key].phone,this.IpdData[key].status,this.IpdData[key].circle_name,this.IpdData[key].hospitalCityName,this.IpdData[key].bd_name,this.IpdData[key].lead_source_name,this.IpdData[key].rtype,this.IpdData[key].referral_person_name,this.IpdData[key].referral_person_number,this.IpdData[key].treatment_name,this.IpdData[key].treatment_categoriesName,this.IpdData[key].doctor_name,this.IpdData[key].hospital_name,this.IpdData[key].payment_mode,this.IpdData[key].lead_time,this.IpdData[key].surgery_date,this.IpdData[key].discharge_date,
            this.removeHtml(this.IpdData[key].consuambleData,2),this.removeHtml(this.IpdData[key].lapsetData,2),this.removeHtml(this.IpdData[key].anaesthetistData,2)];

            if(this.myrole=='1' || this.myrole=='8' || this.myrole=='9' || this.myrole=='14'){
                exdata.push(this.IpdData[key].billed_amt);
                exdata.push(this.IpdData[key].mou_amt);
                exdata.push(this.IpdData[key].copay_amt);
                exdata.push(this.IpdData[key].non_consuamble_amt);
                exdata.push(this.IpdData[key].prop_mou_amt);
                exdata.push(this.IpdData[key].insurance_amt);
                exdata.push(this.IpdData[key].paitent_paid_amt);
                exdata.push(this.IpdData[key].settled_amt);
                exdata.push(this.IpdData[key].doctor_share);
                exdata.push(this.IpdData[key].hospital_share);
                exdata.push(this.IpdData[key].lab_charges);
                exdata.push(this.IpdData[key].medicine_charges);
                exdata.push(this.IpdData[key].ot_charges);
                exdata.push(this.IpdData[key].others_charges);
                exdata.push(this.IpdData[key].glamyo_share);
            }
                data.push(exdata)
            }

            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'ipdtransaction_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    removeHtml(content:string,type:number)
    {
        if(type==1)
        {
            return content.replace(/<[^>]*>/g, '')
        }else if(type==2)
        {
            return content.replace(/<[^>]*>/g, '\n')
        }
    }

    setConsumables()
    {
        if(this.consumablesChk)
        {
            this.columnDrp = [0,6,7,8,21,22,23];
        }
        else
        {
            this.columnDrp = [];
        }
        this.checkIn();
    }

    checkIn()
    {
        let allColumns = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29];
        let allColumns2 = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29];
        if(this.columnDrp.length>0)
        {
            for(let key in this.columnDrp)
            {
                let index = allColumns2.indexOf(this.columnDrp.map(Number)[key]);
                if(index>-1)
                {
                    allColumns2.splice(index,1);
                }
            }
        }else{
            this.columnDrp = allColumns;
            allColumns2 = [];
        }

        this.hideColumn = {columns: allColumns2,indicators: true};
    }

    onBeforeChange = (hotInstance, changes) =>
    {
        let data= this.hotRegisterer.getInstance(this.id).getSourceData();
        let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3]};
        if(saveData.field_name=="discharge_date" || !isNaN(saveData.new_value)){
            this.saveOnChange(saveData);
        }else{
            this.sharedapi.presentToast('Please enter numeric value only');
        }
    }

    async saveOnChange(saveData)
    {
       this.submitted = true;
        await this.leadapi.UpdateIpdUsedResource(saveData).subscribe((data:any) =>
        {
            this.submitted = false;
            this.sharedapi.presentToast(data.msg);
        }, error => {
                this.sharedapi.checkError(error);
        });

    }

    afterOnCellMouseDownCallBack = (event, coords, TD) =>
    {
        if(event.target.nodeName.toLowerCase() == 'button'){
            let ipdtrid = event.target.attributes.id.nodeValue;
            this.viewBilledHistory(ipdtrid);
        }
    }

    async viewBilledHistory(ipd_id)
    {
        this.ipdHistoryDetail=[];
        this.IpdID= ipd_id;
        $('#BilledModal').modal();
        this.billedloading = true;this.billedloaded = false;
        await this.leadapi.viewBilledAmountDetails(ipd_id).subscribe((data:any) => {
            if(data.status)
            {
               this.billedloading = false;this.billedloaded = true;
               this.ipdHistoryDetail=data.data;

            }else{
                this.billedloading = false;this.billedloaded = true;
                this.ipdHistoryDetail = [];

            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    hideModal()
    {
        $('#BilledModal').modal('hide');
    }
}

